<template>
  <span>
    <v-card>
      <v-card-text class="pb-0">
        <v-card-title class="mb-3 pt-0">
          {{ methodologyLabel }}
        </v-card-title>
        <v-card-text>
          <div v-html="methodology.body"></div>
        </v-card-text>
      </v-card-text>
    </v-card>
  </span>
</template>
<script>
import { VERIFIED_EVENTS_METHODOLOGY_LABEL } from "@/common/constants/verifiedEvents";
import { getVerifiedEventsMethodology } from "@/services/common/methodology.service";
export default {
  name: "VerifiedEventDefinitions",
  async mounted() {
    this.methodology = await getVerifiedEventsMethodology();
  },
  data() {
    return {
      methodologyLabel: VERIFIED_EVENTS_METHODOLOGY_LABEL,
      methodology: null,
    };
  },
};
</script>

<style scoped></style>
